// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__2Uj0E","label":"Section_label__q49fC","contentWrap":"Section_contentWrap__1VJCf","footer":"Section_footer__1mlrt","footerInner":"Section_footerInner__38kj2"};